import { PageContainer, PageHeader, VStack } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { commercialPartnersSearchSchema } from '@/hooks/queries/crt/useCommercialPartners'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import CommercialPartnersDataTable from './-components/CommercialPartnersDataTable'

export const Route = createFileRoute('/_auth/_modules/crt/customers/commercial-partners/')({
  component: RouteComponent,
  validateSearch: (search) => commercialPartnersSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')

  return (
    <PageContainer>
      <PageHeader>{t('commercialPartners.pageHeader')}</PageHeader>

      <Card>
        <CardContent className="pt-6">
          <VStack gap="md">
            <CommercialPartnersDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
